import { useState, useEffect } from 'react';

export const usePreviewImages = (files: FileList | null) => {
  const [previewUrls, setPreviewUrls] = useState<string[]>([]);

  useEffect(() => {
    // Convert FileList to Array and create URLs
    if (files) {
      const fileArray = Array.from(files);
      const urls = fileArray.map((file) => URL.createObjectURL(file));
      setPreviewUrls(urls);

      // Cleanup function to revoke URLs when files change or component unmounts
      return () => {
        urls.forEach((url) => URL.revokeObjectURL(url));
      };
    } else {
      setPreviewUrls([]);
    }
  }, [files]);

  return previewUrls;
};
